import type {LucideIcon} from 'lucide-react';
import {getLucideIcon} from './icons';

type Props = {
  name: string;
  size?: number;
  color?: string;
  className?: string;
  fallback?: LucideIcon;
};

function GuidebookIcon({name, size = 24, color, className, fallback}: Props) {
  const Icon = getLucideIcon(name) ?? fallback;
  if (!Icon) return null;

  return <Icon size={size} color={color} className={className} />;
}

export {GuidebookIcon};
